import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export class LoginRequest
{
	public username: string;
	public password: string;

	public constructor(username: string, password: string)
	{
		this.username = username;
		this.password = password;
	}
}

export class LoginResponse
{
	public userId: string;
	public jwt: string;
	public name: string;
	public username: string;
	public credits: number;
	public jurisdictionId: string;
	public jurisdictionName: string;
	public type: string;
	public permissions: string[];
	public currentEmailOrBookingNumber: string;
	public isTempPasswordLogin: boolean;
	public isAttorney: boolean;
	public isPublicDefender: boolean;
	public isInactiveAttorney: boolean;
	public intercomHash: string;
	public hasInmatePortal: boolean;
	public pendingUserCivilianId: string;

	public constructor(userId: string, jwt: string, name: string, username: string, credits: number,
		jurisdictionId: string, jurisdictionName: string, type: string, permissions: string[],
		currentEmailOrBookingNumber: string, isTempPasswordLogin: boolean, isAttorney: boolean,
		isPublicDefender: boolean, isInactiveAttorney: boolean, intercomHash: string, hasInmatePortal: boolean,
		pendingUserCivilianId: string)
	{
		this.userId = userId;
		this.jwt = jwt;
		this.name = name;
		this.username = username;
		this.credits = credits;
		this.jurisdictionId = jurisdictionId;
		this.jurisdictionName = jurisdictionName;
		this.type = type;
		this.permissions = permissions;
		this.currentEmailOrBookingNumber = currentEmailOrBookingNumber;
		this.isTempPasswordLogin = isTempPasswordLogin;
		this.isAttorney = isAttorney;
		this.isPublicDefender = isPublicDefender;
		this.isInactiveAttorney = isInactiveAttorney;
		this.intercomHash = intercomHash;
		this.hasInmatePortal = hasInmatePortal;
		this.pendingUserCivilianId = pendingUserCivilianId;
	}
}

export class PasswordResetRequest
{
	public username: string;

	public constructor(username: string)
	{
		this.username = username;
	}
}

export class UpdatePasswordRequest
{
	public password: string;

	public constructor(password: string)
	{
		this.password = password;
	}
}

export class InmateRegisterAccount
{
	public username: string;
	public password: string;
	public pin: string;

	public constructor(username: string, password: string, pin: string)
	{
		this.username = username;
		this.password = password;
		this.pin = pin;
	}
}

@Injectable()
export class SharedLoginRepository
{
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public login(loginRequest: LoginRequest): Observable<LoginResponse>
	{
		localStorage.removeItem("access_token");
		return this.http.post<LoginResponse>("login", loginRequest);
	}

	public getUser(jwt: string): Observable<LoginResponse>
	{
		return this.http.get<LoginResponse>("login?jwt=" + jwt);
	}

	public logout(): Observable<void>
	{
		return this.http.post<void>("logout", {});
	}

	public resetPassword(resetRequest: PasswordResetRequest): Observable<void>
	{
		return this.http.post<void>("passwordResets", resetRequest);
	}

	public updatePassword(updateRequest: UpdatePasswordRequest): Observable<boolean>
	{
		return this.http.put<boolean>("passwordResets", updateRequest);
	}

	public updatePasswordWithPin(resetId: string, updateRequest: UpdatePasswordRequest): Observable<void>
	{
		return this.http.put<void>(`passwordResets/${resetId}`, updateRequest);
	}

	public register(inmateRegisterAccount: InmateRegisterAccount): Observable<boolean>
	{
		return this.http.post<boolean>("registrations", inmateRegisterAccount);
	}

	public requestTempPassword(loginRequest: LoginRequest): Observable<boolean>
	{
		return this.http.post<boolean>("login/tempPasswordRequest", loginRequest);
	}
}
